import React from 'react';
import PropTypes from 'prop-types';
import CartProp from '../../../propTypes/CartProp';
import ProductProp from '../../../propTypes/ProductProp';
import ProductItem from './ProductItem';
import { isInCart } from '../../../../../services/utilityFunctions';
import PlanProp from '../../../propTypes/PlanProp';

function ProductCategory({
  name,
  products,
  cart,
  isSubscriptionEdit,
  onOpenDescriptionModal,
  interval,
  selectedPlan,
  onClickAddItem,
  onClickRemoveItem,
  hasPermissionToChange,
}) {
  const handleClickAddItem = ({ product, quantity }) => {
    onClickAddItem({ product, quantity });
  };

  const handleClickRemoveItem = product => {
    onClickRemoveItem(product);
  };

  return (
    <div className="row">
      <div className="col-12 subscription-top-trophies-container">
        <h3 className="subscription-options-title">{name}</h3>
        <div className="product-scrolling-wrapper">
          {products.map(ts => (
            <div className="scroll-item m--margin-10" key={ts._id}>
              <ProductItem
                product={ts}
                isInCart={isInCart(cart, ts)}
                isSubscriptionEdit={isSubscriptionEdit}
                onClickAdd={handleClickAddItem}
                onClickRemove={handleClickRemoveItem}
                onOpenDescriptionModal={onOpenDescriptionModal}
                interval={interval}
                selectedPlan={selectedPlan}
                hasPermissionToChange={hasPermissionToChange}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

ProductCategory.propTypes = {
  name: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape(ProductProp.propType)).isRequired,
  cart: PropTypes.shape(CartProp.propType).isRequired,
  onClickAddItem: PropTypes.func.isRequired,
  onClickRemoveItem: PropTypes.func.isRequired,
  onOpenDescriptionModal: PropTypes.func.isRequired,
  isSubscriptionEdit: PropTypes.bool,
  interval: PropTypes.string.isRequired,
  selectedPlan: PropTypes.shape(PlanProp.propType).isRequired,
  hasPermissionToChange: PropTypes.bool,
};

ProductCategory.defaultProps = {
  isSubscriptionEdit: true,
  hasPermissionToChange: true,
};

export default ProductCategory;
